
import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'
import PrimarySection from '@abra/pages/Pricerule/Details/Section/Primary'
import ScheduleSection from '@abra/pages/Pricerule/Details/Section/Schedule'
import GeoSection from '@abra/pages/Pricerule/Details/Section/Geo'
import CeilingSection from './Section/Ceiling'

const Ceiling = ({ company_id, companycontract_id, companyContractLabel }) =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={1}>
      <Grid size={12}>
        <FormHeader
          subTitle={I18n.t('link.ceiling')}
          onLinkClick={() => window.open(`/company/${company_id}/contract/${companycontract_id}`, '_blank')}
          linkText={companyContractLabel}
        />
      </Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[4]} activeStep={0} orientation="vertical">
          <Step><PrimarySection /></Step>
          <Step><ScheduleSection /></Step>
          <Step><GeoSection isCeiling /></Step>
          <Step><CeilingSection /></Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(Ceiling)
